/* eslint-disable */

import Raven from 'raven-js';
import WebFont from 'webfontloader';
import config from './config';

// Google fonts
WebFont.load({
  google: {
    families: [
      'Fira Sans Extra Condensed:400,700',
      'Source Sans Pro:200,400,700',
    ],
  },
});



// WEBPACK FOOTER //
// ./src/init-libs.js